import { Components, Theme } from '@mui/material';

export const MuiPopover: Components<Theme>['MuiPopover'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      zIndex: theme.zIndex.snackbar, // TODO: remove when old modals are gone
    }),
  },
};
